import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import {Record} from 'immutable';
import NavActions from 'actions/NavActions';

@immutableStore
class NavStore {
  constructor() {
    this.state = Record({
      navOverride: null,
      navOverrideProps: null,
      inboxMentionsCount: undefined,
    })();
    this.bindActions(NavActions);
  }

  setNavOverride({navOverride, navOverrideProps}) {
    this.setState(
      this.state.set('navOverride', navOverride).set('navOverrideProps', navOverrideProps)
    );
  }

  clearNavOverride() {
    // just remove the clearing for now.  It causes flashing of the nav
    // this.setState({navOverride: null});
  }

  inboxMentionsCountSuccess(inboxMentions) {
    this.setState(this.state.set('inboxMentionsCount', inboxMentions.count));
  }

  inboxMentionsCountError(e) {
    console.error('failed fetching inbox mention count.');
    console.error(e);
  }
}

export default alt.createStore(NavStore);
